import React from 'react';
import PropTypes from "prop-types";
export var ScreenReaderOnlyDocsComponent = () => <div />;
ScreenReaderOnlyDocsComponent.propTypes = {
  children: PropTypes.element.isRequired,

  /**
     * For keyboard navigation, force content to display visually upon focus.
     */
  showOnFocus: PropTypes.bool
};

try {
  // @ts-ignore
  ScreenReaderOnlyDocsComponent.displayName = "ScreenReaderOnlyDocsComponent"; // @ts-ignore

  ScreenReaderOnlyDocsComponent.__docgenInfo = {
    "description": "",
    "displayName": "ScreenReaderOnlyDocsComponent",
    "props": {
      "showOnFocus": {
        "defaultValue": null,
        "description": "For keyboard navigation, force content to display visually upon focus.",
        "name": "showOnFocus",
        "required": false,
        "type": {
          "name": "boolean | undefined"
        }
      }
    }
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src-docs/src/views/accessibility/props.tsx#ScreenReaderOnlyDocsComponent"] = {
      docgenInfo: ScreenReaderOnlyDocsComponent.__docgenInfo,
      name: "ScreenReaderOnlyDocsComponent",
      path: "src-docs/src/views/accessibility/props.tsx#ScreenReaderOnlyDocsComponent"
    };
} catch (__react_docgen_typescript_loader_error) {}